import React, { Dispatch, SetStateAction } from "react";
import { Input } from "../../../../../Input/Input";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";

interface FaqMemoInputProps {
  memo: string;
  setMemo: Dispatch<SetStateAction<string>>;
  isEditMode: boolean;
}

export default function FaqMemoInput({
  memo,
  setMemo,
  isEditMode,
}: FaqMemoInputProps) {
  return (
    <FaqDetailRow>
      <FaqDetailLabel>관리자 메모</FaqDetailLabel>

      <Input
        style={{ width: "calc(100% - 148px)" }}
        placeholder="직접 입력"
        value={memo}
        onChange={(e) => setMemo(e.target.value)}
        disabled={!isEditMode}
      />
    </FaqDetailRow>
  );
}
